import classNames from 'classnames';
import css from '../styles.module.css';
import { EmojiPicker } from '../../../../../../../../common/components/EmojiPicker/EmojiPicker';
import React from 'react';
import { useView } from '../../hooks/use-view';
import { insertText } from '../../utils';

export const EmojiButton = ({ className, children }) => {
  const view = useView();

  const onEmojiPicked = emoji => {
    if (view?.state && view?.dispatch) {
      insertText(emoji, undefined)(view.state, view.dispatch);
      view.focus?.();
    }
  };

  return (
    <EmojiPicker
      className={classNames(css.emoji, css.button)}
      onEmojiPicked={onEmojiPicked}
    >
      {children}
    </EmojiPicker>
  );
};
